import { useQuery } from 'react-query'
import { gql } from 'graphql-request'

import authService from '../services/authService'
import { User, UserIdTokenResult, UserName } from '../types/user'
import { CustomerUserRole } from '../types/customer-user'
import { BuzzlUserRole } from '../types/buzzl-user'
import { graphQLClient } from '../services/authService'

export function useIsValidUser() {
  return useQuery<UserIdTokenResult | undefined, any, boolean>('valid', () => authService.getAccessTokenResults(), {
    select: (data) => {
      return Boolean(data && data.claims && (data.claims.buzzlRole !== null || data.claims.customerRole !== null))
    },
  })
}

export function useUser() {
  return useQuery<(User & { role: CustomerUserRole | BuzzlUserRole; type: 'CUSTOMER' | 'BUZZL' }) | null>(
    'user',
    () => authService.getUser(),
    {
      select: (user) => {
        if (!user) return null

        if (user.buzzlUser && user.buzzlUser?.role) {
          return {
            ...user,
            role: user.buzzlUser.role,
            type: 'BUZZL',
          }
        }

        if (user.customerUser && user.customerUser?.role) {
          return {
            ...user,
            role: user.customerUser.role,
            type: 'CUSTOMER',
          }
        }

        return null
      },
    }
  )
}

export function useUserByEmail(email: string) {
  return useQuery<UserName, any>(
    ['UserName', email],
    async () => {
      const userName = await graphQLClient.request(
        gql`
          query {
            user(where: { email: "${email}" }) {
              firstName
              lastName
            }
          }
        `,
        {
          where: {
            email: email,
          },
        }
      )

      return userName
    },
    {
      enabled: !!email,
    }
  )
}
